/* eslint-disable react/no-multi-comp */
/* eslint-disable react/jsx-props-no-spreading */
import { QuorumRichTextarea } from "@/components/Controlled//QuorumRichTextarea"
import { MentionList } from "@/components/Controlled/AtMentionRichTextarea/MentionList"
import { formatToDisplay, formatToStore } from "@/components/Controlled/AtMentionRichTextarea/helpers"
import { getSuggestions } from "@/components/Controlled/QuorumRichTextarea/helpers"
import { RichTextEditor } from "@mantine/tiptap"
import React from "react"
import { UseControllerProps } from "react-hook-form"

type AtMentionRichTextareaProps = {
    description: string
    mentionTags: Record<string, string>
    name: string
    placeholder: string
    tooltip?: string
    label: string
} & UseControllerProps

export const AtMentionRichTextarea = ({ mentionTags, name, ...props }: AtMentionRichTextareaProps) => {
    const formatContent = (value: string) => formatToDisplay(value, mentionTags)

    const mentionConfig = {
        suggestion: getSuggestions(
            Object.keys(mentionTags).map((tag) => tag.slice(1)),
            MentionList,
            true,
        ),
    }

    return (
        <QuorumRichTextarea
            {...props}
            name={name}
            formatContent={formatContent}
            mentionConfig={mentionConfig}
            onUpdate={({ field, editor }) => {
                field.onChange(formatToStore(editor.getHTML(), mentionTags))
            }}
            renderToolbar={(editor) => (
                <RichTextEditor.Toolbar sticky stickyOffset={60}>
                    <RichTextEditor.ControlsGroup>
                        <RichTextEditor.Bold />
                        <RichTextEditor.Italic />
                        <RichTextEditor.Underline />
                        <RichTextEditor.Strikethrough />
                        <RichTextEditor.ClearFormatting />
                    </RichTextEditor.ControlsGroup>

                    <RichTextEditor.ControlsGroup>
                        <RichTextEditor.H1 />
                        <RichTextEditor.H2 />
                        <RichTextEditor.H3 />
                        <RichTextEditor.H4 />
                    </RichTextEditor.ControlsGroup>

                    <RichTextEditor.ControlsGroup>
                        <RichTextEditor.BulletList />
                        <RichTextEditor.OrderedList />
                        <RichTextEditor.Subscript />
                        <RichTextEditor.Superscript />
                    </RichTextEditor.ControlsGroup>

                    <RichTextEditor.ControlsGroup>
                        <RichTextEditor.Link />
                        <RichTextEditor.Unlink />
                    </RichTextEditor.ControlsGroup>

                    <RichTextEditor.ControlsGroup>
                        <RichTextEditor.AlignLeft />
                        <RichTextEditor.AlignCenter />
                        <RichTextEditor.AlignJustify />
                        <RichTextEditor.AlignRight />
                    </RichTextEditor.ControlsGroup>
                </RichTextEditor.Toolbar>
            )}
        />
    )
}
